import React from "react";
import { array, object, bool, string } from "prop-types";

import { MenuItem } from "../helper-components";

import "./navbar.m.css";

const Navbar = ({ menu, isVerticalMenubar, domainSlug, lang, navbarMenuStyle }) => (
  <nav styleName="navbar" className="navbar">
    {menu && menu.length > 0 ? (
      <ul styleName="navbar-list" className="navbar-list">
        {menu.map((item, index) => (
          <li
            key={index}
            styleName={`menu-item ${lang}-menu-item ${
              item["item-type"] === "placeholder" ? "menu-item-placeholder" : ""
            }`}
            className={`menu-item ${lang}-menu-item ${
              domainSlug === "kishoralo" && isVerticalMenubar ? "kishoralo-menu-item" : ""
            }`}
            style={navbarMenuStyle}
          >
            <div>
              <MenuItem item={item} />
            </div>
          </li>
        ))}
      </ul>
    ) : null}
  </nav>
);

Navbar.propTypes = {
  menu: array,
  isVerticalMenubar: bool,
  domainSlug: string,
  lang: string,
  navbarMenuStyle: object,
};

export default Navbar;
